module.exports = __webpack_public_path__ + "static/media/strongher3_preview.068ceff6.jpg";